(function () {
    'use strict';

    angular
        .module('invesfleet')
        .controller('InformeListController', InformeListController);


    InformeListController.$inject = [
        '$templateCache', '$scope', '$rootScope', '$state', '$filter', '$q', 'restrictionService', 'reportingService', 'simpleModalService', 'userService', 'notificationService'
    ];



    function InformeListController($templateCache, $scope, $rootScope, $state, $filter, $q, restrictionService, reportingService, simpleModalService, userService, notificationService) {
        var vm = this;

        vm.title = "Informes";
        vm.loadingInformation = false;
        vm.gridData = [];
        vm.reports = [];
        vm.searchText = "";
        vm.showList = false;
        vm.favorites = [];
        vm.groupSelected = 0;
        vm.groups = [{
                id: 1,
                nombre: 'Informes de órdenes'
            },
            {
                id: 2,
                nombre: 'Informes de facturas'
            },
            {
                id: 99,
                nombre: 'Informes favoritos'
            },
            {
                id: 3,
                nombre: 'Informes de flota'
            }, 
            {
                id: 4,
                nombre: 'Informes de empleados'
            }
        ]

        vm.restrictionService = restrictionService;
        vm.deleteReport = deleteReport;
        vm.showReport = showReport;
        vm.clearSearcher = clearSearcher;
        vm.filterGrid = filterGrid;
        vm.getList = getList;
        vm.goToEdit = goToEdit;
        vm.checkFavorites = checkFavorites;
        vm.seleccionGrupos = seleccionGrupos;
        vm.permisoHorario = userService.userData.esAdmin || userService.userData.esSupervisor; 

        (function () {
            loadData();
        })();

        function loadData() {
            vm.loadingInformation = false;
            reportingService.getReports().then(function (response) {
                vm.reports = response.data;
                vm.gridData = response.data;
                reportingService.getFavorites().then(function (response) {
                    vm.favorites = response.data;
                    vm.loadingInformation = true;
                });
            });

        }

        function showReport(id) { //quitar if cuando fran termine
            ////blurred
            // if(id == 27 || id == 28) {
            //     $state.go('flota.informes.nopremium', {
            //         'id': id
            //     });

            // }
            // else {
            //     restrictionService.hasPermission('leer', 'informe', 'flota.informes.detalle', {
            //         'id': id
            //     });
            // }

            //normal
            $state.go('flota.informes.detalle', {
               'id': id
            });
         
        }

        function deleteReport(report) {
            simpleModalService.yesNoModal('Confirmación eliminar',
                    '¿Desea eliminar este report?')
                .then(function (result) {
                    if (result) {
                        reportingService.deleteReport(report.id)
                            .then(function (response) {
                                vm.reports.splice(vm.reports.indexOf(report), 1);
                                vm.gridData.splice(vm.gridData.indexOf(report), 1);
                            });
                    }
                });

        }

        function goToEdit(report) {
            // console.log(userService.userData); 
            var idx = userService.userData.restrictions.findIndex(x => x.entidad == 'informe');
            if( idx != -1 && (userService.userData.restrictions[idx].tipo & 2) == 2) {
                sendErrorNotification("No tiene los permisos adecuados, consulte con el administrador!"); 
            }
            else {
                $state.go('flota.informes.editarInforme', {
                    'id': report.id
                });
            }

        }

        function sendErrorNotification(msg) {
            notificationService.sendAppNotification({
                message: msg,
                positionY: 'top',
                positionX: 'right',
                delay: 3000,
                type: 'info'
            });
        }

        function filterGrid() {
            vm.showList = true;
            if (vm.searchText !== '') {
                vm.gridData = $filter('searchFilter')(vm.gridData, {
                    'id': vm.searchText,
                    'name': vm.searchText,
                    'grupo': vm.searchText,
                }, true);
            } else {
                vm.clearSearcher();
            }
            $rootScope.$apply();

            //vm.gridApi.core.notifyDataChange(uiGridConstants.dataChange.ALL);
        }

        function clearSearcher() {
            vm.searchText = "";
            vm.showList = false;
            if (vm.groupSelected == 0) vm.gridData = vm.reports;
            else {
                getList(vm.groupSelected);
            }
            $rootScope.$apply();
            //vm.gridApi.core.notifyDataChange(uiGridConstants.dataChange.ALL);
        }

        function getList(id) {
            vm.groupSelected = id;
            vm.title = vm.groups.find(x => x.id == id).nombre;
            if (id == 99) { //Favoritos
                vm.gridData = vm.reports.filter(report => vm.favorites.filter(x => x.reportId == report.id).length > 0);
            } else { //grupos
                vm.gridData = vm.reports.filter(report => report.grupoId == id);
            }
            vm.showList = true;
            //vm.gridApi.core.notifyDataChange(uiGridConstants.dataChange.ALL);
        }

        function checkFavorites(id) {
            var idx = vm.favorites.findIndex(x => x.reportId == id);
            var bool = idx != -1;
            return bool;
        }

        function seleccionGrupos() {
            vm.title = 'Informes';
            vm.showList = false;
            vm.gridData = vm.reports;
            vm.groupSelected = 0;
        }

    }

})();